// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homework-header{
    border:1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    width: 287px;
    font-size: 16px;
}

.homework-detail{
    background-color: rgba(43, 167, 105, 1);
    border-radius: 10px;
    width: 100%;
    color:white;
    padding:8px 10px;
    font-size: 13px;
}

.bg-detail{
    background-color: rgba(247, 247, 247, 1) !important;
    color: black;
}

.times{
    width: 30px;
    border-radius: 50%;
    padding:2px 0;
    margin: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/homework.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mDAAmD;IACnD,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB","sourcesContent":[".homework-header{\n    border:1px solid rgba(211, 211, 211, 1);\n    border-radius: 5px;\n    width: 287px;\n    font-size: 16px;\n}\n\n.homework-detail{\n    background-color: rgba(43, 167, 105, 1);\n    border-radius: 10px;\n    width: 100%;\n    color:white;\n    padding:8px 10px;\n    font-size: 13px;\n}\n\n.bg-detail{\n    background-color: rgba(247, 247, 247, 1) !important;\n    color: black;\n}\n\n.times{\n    width: 30px;\n    border-radius: 50%;\n    padding:2px 0;\n    margin: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
